import React from 'react';
import { IconArrowUpRight } from '../icons.js';
import './match-badge.css';

// Match percentage badge (Kaan, 5 Kasım 2026; Wrangle reference). Every listed event is already a good match, so the
// colour only deepens with the percentage: 60s light, 70s medium, 80+ solid green.
export const matchTone = value => value >= 80 ? 3 : value >= 70 ? 2 : 1;
export function MatchBadge({ value, label = 'eşleşme', size = 'sm', className = '' }) {
  if (!Number.isFinite(value)) return null;
  return <span className={`bs-match-badge ${className}`.trim()} data-tone={matchTone(value)} data-size={size} title={`%${value} ${label}`} aria-label={`%${value} ${label}`}>
    <IconArrowUpRight size={size === 'lg' ? 15 : 12} aria-hidden="true" /><span aria-hidden="true">%{value}</span>
  </span>;
}
